:host {
  display: block;
  margin: 0;
  background-position: left top;
  background-repeat: no-repeat;
  background-size: cover;
  width: inherit;
}
